import { Action } from 'redux'

import { File } from '../../lib/interfaces/File.interface'
import { ClaimInvoice } from '../../lib/interfaces/ClaimInvoice.interface'

export const actionTypes = {
  INVOICES_FETCH_LIST: 'INVOICES_FETCH_LIST',
  INVOICES_FETCH_LIST_FAILED: 'INVOICES_FETCH_LIST_FAILED',
  INVOICES_FETCH_LIST_SUCCESS: 'INVOICES_FETCH_LIST_SUCCESS',

  INVOICE_FETCH: 'INVOICE_FETCH',
  INVOICE_FETCH_FAILED: 'INVOICE_FETCH_FAILED',
  INVOICE_FETCH_SUCCESS: 'INVOICE_FETCH_SUCCESS',

  INVOICES_CREATE: 'INVOICES_CREATE',
  INVOICES_CREATE_FAILED: 'INVOICES_CREATE_FAILED',
  INVOICES_CREATE_SUCCESS: 'INVOICES_CREATE_SUCCESS',

  INVOICES_UPLOAD_FILE: 'INVOICES_UPLOAD_FILE',
  INVOICES_UPLOAD_FILE_FAILED: 'INVOICES_UPLOAD_FILE_FAILED',
  INVOICES_UPLOAD_FILE_SUCCESS: 'INVOICES_UPLOAD_FILE_SUCCESS',

  INVOICES_FETCH_FILES: 'INVOICES_FETCH_FILES',
  INVOICES_FETCH_FILES_FAILED: 'INVOICES_FETCH_FILES_FAILED',
  INVOICES_FETCH_FILES_SUCCESS: 'INVOICES_FETCH_FILES_SUCCESS',

  INVOICES_PAY: 'INVOICES_PAY',
  INVOICES_PAY_FAILED: 'INVOICES_PAY_FAILED',
  INVOICES_PAY_SUCCESS: 'INVOICES_PAY_SUCCESS',

  INVOICES_DELETE: 'INVOICES_DELETE',
  INVOICES_DELETE_FAILED: 'INVOICES_DELETE_FAILED',
  INVOICES_DELETE_SUCCESS: 'INVOICES_DELETE_SUCCESS',

  INVOICES_ADD_TRACKING: 'INVOICES_ADD_TRACKING',
  INVOICES_ADD_TRACKING_FAILED: 'INVOICES_ADD_TRACKING_FAILED',
  INVOICES_ADD_TRACKING_SUCESS: 'INVOICES_ADD_TRACKING_SUCESS'
}

/**
 * Fetch Invoices
 */
export interface InvoicesFetchListAction extends Action {
  payload: {
    next?: () => void
  }
}

export const fetchInvoicesList = (next?: () => void): InvoicesFetchListAction => ({
  type: actionTypes.INVOICES_FETCH_LIST,
  payload: { next }
})

// Success
export interface InvoicesFetchListSuccessAction extends Action {
  payload: {
    invoices: [ClaimInvoice],
  }
}

export const fetchInvoicesListSuccess = (invoices: [ClaimInvoice]): InvoicesFetchListSuccessAction => ({
  type: actionTypes.INVOICES_FETCH_LIST_SUCCESS,
  payload: { invoices },
})

// Error
export interface InvoicesFetchListErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const fetchInvoicesListError = (errorMessage?: string): InvoicesFetchListErrorAction => ({
  type: actionTypes.INVOICES_FETCH_LIST_FAILED,
  payload: { errorMessage }
})

/**
 * Fetch single Invoice
 */
export interface InvoiceFetchAction extends Action {
  payload: {
    invoiceId: number|string
    next?: (error?: any, invoice?: ClaimInvoice) => void
  }
}

export const fetchInvoice = (invoiceId: number|string, next?: (error?: any, invoice?: ClaimInvoice) => void): InvoiceFetchAction => ({
  type: actionTypes.INVOICE_FETCH,
  payload: { next, invoiceId }
})

// Success
export interface InvoiceFetchSuccessAction extends Action {
  payload: {
    invoice: ClaimInvoice
  }
}

export const fetchInvoiceSuccess = (invoice: ClaimInvoice): InvoiceFetchSuccessAction => ({
  type: actionTypes.INVOICE_FETCH_SUCCESS,
  payload: { invoice }
})

// Error
export interface InvoiceFetchErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const fetchInvoiceError = (errorMessage?: string): InvoiceFetchErrorAction => ({
  type: actionTypes.INVOICE_FETCH_FAILED,
  payload: { errorMessage }
})

/**
 * Create Invoice
 */
export interface InvoiceCreateAction extends Action {
  payload: {
    claimIds: number[],
    next?: () => void
  }
}

export const createInvoice = (claimIds: number[], next?: () => void): InvoiceCreateAction => ({
  type: actionTypes.INVOICES_CREATE,
  payload: { next, claimIds }
})

// Success
export interface InvoiceCreateSuccessAction extends Action {
  payload: {
    invoice: ClaimInvoice
  }
}

export const createInvoiceSuccess = (invoice: ClaimInvoice): InvoiceCreateSuccessAction => ({
  type: actionTypes.INVOICES_CREATE_SUCCESS,
  payload: { invoice }
})

// Error
export interface InvoiceCreateErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const createInvoiceError = (errorMessage?: string): InvoiceCreateErrorAction => ({
  type: actionTypes.INVOICES_CREATE_FAILED,
  payload: { errorMessage }
})

/**
 * Upload Invoice File
 */
export interface InvoiceUploadFileAction extends Action {
  payload: {
    file: any
    invoiceId: number|string
  }
}

export const uploadInvoiceFile = (invoiceId: number|string, file: any): InvoiceUploadFileAction => ({
  type: actionTypes.INVOICES_UPLOAD_FILE,
  payload: { file, invoiceId }
})

// Success
export const uploadInvoiceFileSuccess = (): Action => ({
  type: actionTypes.INVOICES_UPLOAD_FILE_SUCCESS
})

// Error
export interface InvoiceUploadFileErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const uploadInvoiceFileError = (errorMessage?: string): InvoiceUploadFileErrorAction => ({
  type: actionTypes.INVOICES_UPLOAD_FILE_FAILED,
  payload: { errorMessage }
})

/**
 * Fetch Invoice Files
 */
export interface InvoiceFetchFilesAction extends Action {
  payload: {
    invoiceId: number|string
  }
}

export const fetchInvoiceFiles = (invoiceId: number|string): InvoiceFetchFilesAction => ({
  type: actionTypes.INVOICES_FETCH_FILES,
  payload: { invoiceId }
})

// Success
export interface InvoiceFetchFilesSuccessAction extends Action {
  payload: {
    files: File[],
    invoiceId: number
  }
}

export const fetchInvoiceFilesSuccess = (files: File[], invoiceId: number): InvoiceFetchFilesSuccessAction => ({
  type: actionTypes.INVOICES_FETCH_FILES_SUCCESS,
  payload: { files, invoiceId }
})

// Error
export interface InvoiceFetchFilesErrorAction extends Action {
  payload: {
    errorMessage: string
  }
}

export const fetchInvoiceFilesError = (errorMessage: string): InvoiceFetchFilesErrorAction => ({
  type: actionTypes.INVOICES_FETCH_FILES_FAILED,
  payload: { errorMessage }
})

/**
 * Pay Invoice
 */
export interface InvoicePayAction extends Action {
  payload: {
    datePaid: string
    checkNumber: string
    invoiceId: number|string
    next?: (err?: any, invoice?: ClaimInvoice) => void
  }
}

export const payInvoice = (invoiceId: number|string, datePaid: string, checkNumber: string, next?: (err?: any, invoice?: ClaimInvoice) => void): InvoicePayAction => ({
  type: actionTypes.INVOICES_PAY,
  payload: { next, datePaid, invoiceId, checkNumber }
})

// Success
export interface InvoicePaySuccessAction extends Action {
  payload: {
    invoice: ClaimInvoice
  }
}

export const payInvoiceSuccess = (invoice: ClaimInvoice): InvoicePaySuccessAction => ({
  type: actionTypes.INVOICES_PAY_SUCCESS,
  payload: { invoice }
})

// Error
export interface InvoicePayErrorAction extends Action {
  payload: {
    errorMessage: string
  }
}

export const payInvoiceError = (errorMessage: string): InvoicePayErrorAction => ({
  type: actionTypes.INVOICES_PAY_FAILED,
  payload: { errorMessage }
})

/**
 * Delete Invoice
 */
export interface InvoiceDeleteAction extends Action {
  payload: {
    invoiceId: number|string
    next?: (err?: any) => void
  }
}

export const deleteInvoice = (invoiceId: string|number, next?: (err?: any) => void): InvoiceDeleteAction => ({
  type: actionTypes.INVOICES_DELETE,
  payload: { next, invoiceId }
})

// Success
export interface InvoiceDeleteSuccessAction extends Action {
  payload: {
    invoiceId: number|string
  }
}

export const deleteInvoiceSuccess = (invoiceId: string|number): InvoiceDeleteSuccessAction => ({
  type: actionTypes.INVOICES_DELETE_SUCCESS,
  payload: { invoiceId }
})

// Error
export interface InvoiceDeleteErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const deleteInvoiceError = (errorMessage?: string): InvoiceDeleteErrorAction => ({
  type: actionTypes.INVOICES_DELETE_FAILED,
  payload: { errorMessage }
})

// Add Tracking
export interface InvoiceAddTrackingAction extends Action {
  payload: {
    invoiceId: string
    mailTracking: string
    next?: (err?: any) => void
  }
}

export const addInvoiceTracking = (invoiceId: string, mailTracking: string, next?: (err?: any) => void): InvoiceAddTrackingAction => ({
  type: actionTypes.INVOICES_ADD_TRACKING,
  payload: {invoiceId, mailTracking, next}
})

// Add Tracking Success
export interface InvoiceAddTrackingSuccessAction extends Action {
  payload: { invoice }  
}

export const addInvoiceTrackingSuccess = (invoice: ClaimInvoice): InvoiceAddTrackingSuccessAction => ({
  type: actionTypes.INVOICES_ADD_TRACKING_SUCESS,
  payload: { invoice }
})

// Add Tracking Error
export interface InvoiceAddTrackingErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const addInvoiceTrackingError = (errorMessage?: string): InvoiceAddTrackingErrorAction => ({
  type: actionTypes.INVOICES_ADD_TRACKING_FAILED,
  payload: { errorMessage }
})

/**
 * Action Types
 */
export type ActionTypes = InvoicesFetchListAction



// WEBPACK FOOTER //
// ./src/store/invoices/actions.ts